import _ from 'underscore';
import Radio from 'backbone.radio';


    var globalCh = Radio.channel('global');
    function show_dialog(dialog) {
        var layout = globalCh.request('app_layout');
        var region = layout.getRegion('dialogs');
        if (!region) {
            // This could happen in a layout (such as login layout)
            // which doesn't have a placeholder for the dialog.
            return console.warn('Couldn\'t find a dialog region');
        }

        // If there's already a dialog open, close it before showing the new one
        if (region.hasView()) {
            region.$el.one('hidden.bs.modal', _.bind(function() {
                layout.showChildView('dialogs', dialog);
            }, this));
            region.$el.children().modal('hide');
        } else {
            layout.showChildView('dialogs', dialog);
        }
    }
    export default show_dialog;

